<div class="epds_mat_override">
  <div [ngClass]="{ 'visually-hidden': (selectedUser && addOrEditInd) || editAddress }"
       class="agency-users-container" fxLayout="column" fxLayoutAlign="start start">
    <div fxLayout="row" style="width: 100%">
      <div class="manage-agency-card" fxFlex>
        <mat-card>
          <mat-card-header>
            <mat-card-title role="heading" aria-level="1">Select Agency Tier</mat-card-title>
          </mat-card-header>
          <mat-card-content fxLayout="row" fxLayoutAlign="start center" >
                <app-agency #agencies fxFill (agencies)="onSelectedAgencies($event)" [tier2Required]="true" [layout]="'column'"></app-agency>
          </mat-card-content>

          <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="16px">
            <button mat-raised-button color="primary" (click)="setAddOrEditInd('A')"
                    [disabled]="!selectedAgencies || !selectedAgencies.tier1Agency.agency_Id || !agencies.form.valid">
              Register New Agency User
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>

    <div fxLayout="row wrap" style="width: 100%">
      <ng-container *ngFor="let selectedUser of agencyContactList">
        <div class="agency-contact-card" fxFlex="50">

          <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title role="heading" aria-level="1" fxLayout="row" fxLayoutAlign="space-between">
                  <section>{{ selectedUser?.first_Name }} {{ selectedUser?.last_Name }}</section>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content fxLayout="row" fxLayoutAlign="center" class="user-card-content">
              <div fxFlex="90" fxLayout="column" fxLayoutGap="8px">
                <p><strong>Phone Number:</strong> {{ selectedUser?.phone_No}}</p>
                <p><strong>Email:</strong> {{ selectedUser?.email}}</p>
                <p><strong>Firm Name:</strong> {{ selectedUser?.firm_Name}}</p>
                <p>
                  <strong>Address:</strong>
                  <br>
                    <span *ngIf="selectedUser?.address1" class="card-contact-address1">
                      {{  selectedUser?.address1 +
                        (selectedUser?.address2 ? (', ' + selectedUser?.address2) : '')
                      }}
                    </span>
                  <br>
                  <span class="card-contact-city">
                    {{ (selectedUser?.city ?? '') + (selectedUser?.state ? ((selectedUser?.city ? ', ' : '') + selectedUser?.state) : '') + ' ' + (selectedUser?.zip_Code ?? '') }}
                  </span>
                  <br>
                  <span *ngIf="selectedUser?.country" class="card-contact-country">
                    {{selectedUser?.country}}
                  </span>
                </p>
              </div>
            </mat-card-content>

            <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="16px">
              <button mat-raised-button color="warn" style="margin-top: 16px;" (click)="setAddOrEditInd('E', selectedUser)">
                <mat-icon>edit</mat-icon> Update</button>
            </mat-card-actions>

          </mat-card>

        </div>
      </ng-container>

    </div>

    <div *ngIf="$any(agencyContactList)?.length > 0" class="agency-address-section" fxLayout="row" fxLayoutAlign="start start" style="width: 100%" >
      <div class="agency-address-card" fxFlex="50" >
        <mat-card>
          <mat-card-header>
            <mat-card-title role="heading" aria-level="1">Agency Address</mat-card-title>
          </mat-card-header>

          <mat-card-content fxLayout="row" fxLayoutAlign="center" class="user-card-content">
            <div fxFlex="90" fxLayout="column" fxLayoutGap="8px">
              <p>
                <strong>Address:</strong>
                <br>
                  <span *ngIf="agencyAddress?.address1" class="card-address-address1">
                    {{  agencyAddress?.address1 +
                      (agencyAddress?.address2 ? (', ' + agencyAddress?.address2) : '')
                    }}
                  </span>
                <br>
                <span class="card-address-city">
                  {{ (agencyAddress?.city ?? '') + (agencyAddress?.state ? ((agencyAddress?.city ? ', ' : '') + agencyAddress?.state) : '') + ' ' + (agencyAddress?.zipCode ?? '') }}
                </span>
                <br>
                <span *ngIf="agencyAddress?.country" class="card-address-country">
                    {{agencyAddress?.country}}
                </span>
              </p>

            </div>
          </mat-card-content>

          <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="16px">
            <button mat-raised-button color="warn" style="margin-top: 16px;" (click)="onAddressUpdate()">
              <mat-icon>edit</mat-icon>Update Agency Address</button>
          </mat-card-actions>

        </mat-card>
      </div>
    </div>


  </div>

  <ng-container *ngIf="selectedUser && addOrEditInd">
    <epds-add-or-edit-agency-contact [user]="selectedUser"
                                     (btnClicked)="handleContactForm($event)"
                                     [addOrEditInd]="addOrEditInd"
                                     [showAddress]="!agencyContactList"
                                     [saving]="saving">
    </epds-add-or-edit-agency-contact>
  </ng-container>

  <ng-container *ngIf="selectedUser && editAddress">
    <epds-add-or-edit-agency-contact [user]="selectedUser"
                                     (btnClicked)="handleContactForm($event)"
                                     [addOrEditInd]="'E'"
                                     [showAddress]="true"
                                     [addressMode]="true"
                                     [saving]="saving">
    </epds-add-or-edit-agency-contact>
  </ng-container>

</div>
